import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Pastor Roberto Mendoza',
    role: 'Líder de Iglesia, Ciudad de México',
    quote: 'He comprado docenas de comentarios bíblicos y cursos online, y este material es claramente el mejor que existe en el mercado en todos los aspectos. Tiene una profundidad increíble pero con un lenguaje que cualquier persona puede entender. Las explicaciones versículo por versículo son detalladas y las aplicaciones prácticas cambiaron mi forma de predicar.',
    title: 'La Mejor Colección de Estudios Bíblicos'
  }, {
    name: 'María Elena Contreras',
    role: 'Líder de Grupo de Estudio, Bogotá, Colombia',
    quote: 'Recibí este material hace unos días y no he podido dejarlo. Hay explicaciones claras con contexto completo de cada epístola. ¡Resultó ser aún mejor de lo que esperaba! Las explicaciones son súper fáciles de leer y comprender, a diferencia de otros materiales que encontré por internet.',
    title: 'Las Explicaciones Son Súper Fáciles de Entender'
  }, {
    name: 'Hermano Daniel Gutiérrez',
    role: 'Estudiante de Teología, Lima, Perú',
    quote: 'De todos los materiales bíblicos que he comprado a lo largo de los años, esta es la mejor colección que tengo. Es un recurso excelente tanto para principiantes como para predicadores experimentados. Me habría encantado tener esto cuando empecé a predicar hace 15 años.',
    title: 'Una Inversión Excelente Para Cualquier Cristiano'
  }, {
    name: 'Carlos Eduardo Ramírez',
    role: 'Diácono, Santiago, Chile',
    quote: 'He gastado dinero en materiales que prometían mucho y entregaban poco, pero este recurso me demostró que estaba equivocado y no podría estar más contento con la compra. Para un principiante, este paquete es un regalo del cielo porque obtienes cada detalle que necesitas.',
    title: 'Me Habían Decepcionado Antes, Pero Esto Superó Mis Expectativas'
  }];
  return <section className="py-12 md:py-16 relative" style={{
    background: '#F6F1E7'
  }} data-id="element-268">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-269">
        <div className="text-center mb-8" data-id="element-270">
          <h2 className="text-2xl md:text-3xl font-serif font-bold mb-2" style={{
          color: '#1C1C1C'
        }} data-id="element-271">
            Lo Que Dicen Nuestros Estudiantes
          </h2>
          <div className="mx-auto w-20 gold-divider" data-id="element-272" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-273">
          {testimonials.map((t, i) => <div key={i} className="p-5 rounded-xl" style={{
          background: '#FBF8F2',
          border: '1px solid rgba(200,169,106,0.2)',
          boxShadow: '0 2px 12px rgba(60,40,10,0.05)'
        }} data-id="element-274">
              <div className="flex mb-3" data-id="element-275">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 fill-current" style={{
              color: '#C8A96A'
            }} data-id="element-276" />)}
              </div>
              <h3 className="font-serif font-bold text-sm mb-2" style={{
            color: '#B89555'
          }} data-id="element-277">
                "{t.title}"
              </h3>
              <p className="text-xs leading-relaxed mb-4 italic" style={{
            color: '#6B6B6B'
          }} data-id="element-278">
                "{t.quote}"
              </p>
              <div className="flex items-center" data-id="element-279">
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold mr-2.5 flex-shrink-0" style={{
              background: 'rgba(200,169,106,0.15)',
              border: '1px solid rgba(200,169,106,0.35)',
              color: '#B89555'
            }} data-id="element-280">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-281">
                  <p className="font-bold text-xs" style={{
                color: '#1C1C1C'
              }} data-id="element-282">
                    {t.name}
                  </p>
                  <p className="text-xs" style={{
                color: '#9A9A9A'
              }} data-id="element-283">
                    {t.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}